module.exports = __webpack_public_path__ + "img/sdk-icon.7756552f.png";